import React, {useState, useEffect, useRef} from 'react';
import {useNavigate} from "react-router-dom";
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import {  Input,message,Modal,Progress,Statistic  } from 'antd';
import { transfer,transferBnb,balanceOf } from '../../utils/ethers'
import copy from 'copy-to-clipboard'
import {shareLink} from '../../utils/const'
import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import CountUp from "react-countup";

import { useTranslation } from 'react-i18next'
import {getIdoInfo, addIdoBnb,addIdoJie} from "../../api";
import { CSSTransition } from 'react-transition-group';
import {
    WarningOutlined,CloseOutlined
  } from '@ant-design/icons';
  import './index.less';

import { max } from 'moment';
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        pAddress:state.pAddress,
        chain:state.chain,
        flash:state.flash,
    }
}
const { Countdown } = Statistic;
const Mint = (props) => {
    const navigate = useNavigate()
    const audioRef = useRef(null);
    const { t } = useTranslation()
    const [num,setNum] = useState(0)
    const [mars,setMars] = useState(0)
    const [mintBnb,setMintBnb] = useState(0)
    const [levelJie,setLevelJie] = useState(0)
    const [receiveAddress,setReceiveAddress] = useState("")
 const [isLock,setIsLock]=useState(false)
const [balanceUsdt,setBalanceUsdt]=useState(null)
 const [needUsdt,setNeedUsdt] = useState(5000)
const [myNode,setMyNode] = useState("")
    const [mints,setMints] = useState(10)
 
    const [pm,setPm] = useState(500000)
    const [bnb,setBnb] = useState(0.1)

    const [minted,setMinted] = useState(0)
    const [maxMint,setMaxMint] = useState(0)
  
    const [per,setPer] = useState(0)
    const [isOpen,setIsOpen] = useState(true)
    const [showMint,setShowMint] = useState(false)
    const ref = useRef()

    const [nodeIndex , setNodeIndex] = useState(2)


    const _showMint = (e) =>{
        setShowMint(e)
    }

    const _getTuanInfo = () =>{
        if(props.address.length>0 && props.isLogin){
            getIdoInfo().then(res=>{
                if(res.code == 0){
                    setReceiveAddress(res.data.receive)
                    setLevelJie(res.data.levelJie)
                    setMars(res.data.meba)
                    setMintBnb(res.data.eth)
                    setMaxMint(res.data.total)
                    setMinted(res.data.minted)
                    setPer(res.data.per)
                      setMyNode(res.data.node)
                  
                    
                }else{
                    message.error(res.msg)
                }
               console.log(res)
            })
        }
    }

    const handleChange = (value) => {
        const regex = /^[0-9]*$/;
        
        if (regex.test(value) || value === '') {
         if(value>1000){
            value = 1000
         }
          setMints(value);
          setPm(parseInt(value*50000*100)/100);
          setBnb(parseInt(value*0.01*100)/100);
        }
    }

    const addNode = () => {
        if(needUsdt == 1000){
            setNeedUsdt(3000)
        }else if(needUsdt == 3000){
            setNeedUsdt(5000)
        }else if(needUsdt == 5000){
            setNeedUsdt(1000)
        }
    }

    const subNode = () => {
        if(needUsdt == 1000){
            setNeedUsdt(5000)
        }else if(needUsdt == 3000){
            setNeedUsdt(1000)
        }else if(needUsdt == 5000){
            setNeedUsdt(3000)
        }
    }

    const add = () => {
        let value = 1
        if(mints.length==0){
             value = 1
        }else{
             value = parseInt(mints) +1
        }
        
        const regex = /^[0-9]*$/;
        
        if (regex.test(value) || value === '') {
         if(value>1000){
            value = 1000
         }
         setMints(value);
          setPm(parseInt(value*50000*100)/100);
          setBnb(parseInt(value*0.01*100)/100);
        }
    }

    const sub = () => {
        let value = 1
        if(mints.length==0){
            value = 1
        }else{
            value = mints -1
        }
        
        if (value <1){
            value =1
        }
        const regex = /^[0-9]*$/;
        
        if (regex.test(value) || value === '') {
         if(value>1000){
            value = 1000
         }
         setMints(value);
         setPm(parseInt(value*50000*100)/100);
          setBnb(parseInt(value*0.01*100)/100);
        }
    }

    

   


    const _balanceOf = () =>{
        
        if(props.address.length<=0 || !props.isLogin) return false
      
        balanceOf(props.address,'usdt').then(res=>{
            
            setBalanceUsdt(res)
        })

    }


    const _rand= () =>{
        // let address1 = (props.address).toLowerCase()
        // console.log(address1)
        // if(address1!= "0xecE259eeF7c8A1449a415A8b83Bf9622A41300e9"){
        //     message.error(t('g.暂未开始'))
        //     return
        // }
        
        if(props.address.length<=0) return false
        // message.error(t('in.暂未开放'))
        // return false
          
          
        // let nowTime = Date.parse(new Date()) / 1000
        // if( nowTime < 1734175800){
        //     message.error(t('in.暂未开放'))
        //     return false
        // }
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            // message.error(t('mint.请先绑定推荐地址!'))
            props.setFlash(true)
            return false
        }
        if(receiveAddress.length==0){
              message.error(t('mint.钱包地址获取错误'))
            return false
        }



   

        if (parseInt(needUsdt)!=1000  && parseInt(needUsdt)!=3000 && parseInt(needUsdt)!=5000){
            return false
        }
      

        if(parseFloat(needUsdt)>parseFloat(balanceUsdt)){
           
            message.error(t('mint.您的USDT不足'))
            return false
        }

        if(isLock){
            return false
        }
        setIsLock(true)



                transfer(props.address,receiveAddress,"usdt",needUsdt).then(
                    res=>{
                        addIdoJie({
                            address:props.address,
                            value:needUsdt.toString(),
                            hex:res.hash,
                        }).then(
                            res=>{
                                message.success(res.msg)
                                
                                setNum(num+1);
                                setIsLock(false)
                            })
                    }, error=>{
                        setIsLock(false)
                        message.error(error)
                    })





    }

 

    const _isStartIdo = () =>{
        return
    //  message.error(t('g.暂未开始'))
    //         return
    // let now = Date.now() /1000
    // if(parseFloat(now) < 1756812600){
    //       message.error(t('g.暂未开始'))
    //         return
    // }
        setIsOpen(true)
        
        if(props.address.length === 0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            // message.error(t('mint.请先绑定推荐地址!'))
            props.setFlash(true)
            return false
        }
        if(receiveAddress.length==0){
              message.error(t('mint.钱包地址获取错误'))
            return false
        }
        if(bnb.length==0){
             message.error(t('mint.请重新输入船票数量'))
             return false
        }
        if(parseFloat(bnb)<0.01 || parseFloat(bnb)>10){
            message.error(t('mint.每个地址购买船票数不能超出1000'))
            return false
       }
       if(isLock){
            return false
        }
        setIsLock(true)
      
        transferBnb(props.address,receiveAddress,bnb).then(
            res2=>{
                // message.success(res2)
               addIdoBnb({
                    address:props.address,
                    mints:mints.toString(),
                    hex:res2.hash,
                    
                }).then(
                    res=>{
                        audioRef.current.play()
                        setIsOpen(false)
                        message.success(res.msg)
                     
                        setNum(num+1);
                        setIsLock(false)
                    })
                       
                    
            },err2=>{
                setIsLock(false)
                message.error(err2)
            }
        )
    }

    const changeNode = (e) =>{
        console.log(e)
        setNodeIndex(e)
        if(e==0){
            setNeedUsdt(1000)
        }else if(e==1){
            setNeedUsdt(3000)
        }else if(e==2){
            setNeedUsdt(5000)
        }
    }
  
const goUrl = (url)=>{
       
        if(props.address.length<=0 ){
            message.error(t('head.请先连接钱包'))
            return false
        }
        navigate(url,{
            state:{
                address:props.address
            }
        })
    }


    const openNewPagex = () => {
        window.open('https://x.com/IPM_MARS', '_blank');
      };

      const openNewPaget = () => {
        window.open('https://t.me/InterstellarProtocolMARS', '_blank');
      };

    useEffect(() => {
        window.scrollTo(0, 0)
            // if(props.address.length>0 && !props.isLogin){
            //     setShowJoin(true)
            // }
            // _allIdoETH()
            // _getIdoList()



            _balanceOf()
             _getTuanInfo()
            // const timer = setInterval(() =>{_getTuanInfo()},20000)
            // ref.current = timer
            // return ()=>{
            //     clearInterval(ref.current)
            // }
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    const clearTimer = () =>{
        clearInterval(ref.current)
    }

    return (
        <>
            <Head/>
     
           
                        
            
            <div className=' invitebg w-full lg:w-1/3  px-4 pt-20 text-white flex flex-col z-10'>
                <div className=' w-full h-16 mt-6 pt-1 flex flex-col justify-center items-center title_bg1 '>
                    <span className='  text-text-act' style={{"fontSize":"12px"}}>{t('mint.船票任务')}</span>
                    <span className='  text-base'><Countdown title=""  valueStyle={{"fontSize":"20px","color":"#FFFFFF","font-weight":"700"}} value={1757433600*1000} format={`DD : HH : mm : ss`} /></span>
                </div>


                <div className=' w-full flex flex-row justify-around mt-9 mb-8'>
                    <div className='  w-80 flex flex-row justify-center items-center '>
                        {/* <button  onClick={()=>_showMint(true)} className='w-full h-12    mintTabBg1 text-text-act font-extrabold ' style={{"fontSize":"12px"}}>{t('mint.船票兑换')}</button> */}
                         <button  onClick={()=>_showMint(false)} className='w-full h-12    mintTabBg2  text-text-act font-extrabold ' style={{"fontSize":"12px"}}>{t('mint.节点兑换')}</button>
                    </div>
                    <div className='w-80 flex flex-row justify-center items-center '>
                        {/* <button  onClick={()=>_showMint(false)} className='w-full h-12    mintTabBg2  text-text-act font-extrabold ' style={{"fontSize":"12px"}}>{t('mint.节点兑换')}</button> */}
                        <button  onClick={()=>goUrl("/nft")} className='w-full h-12    mintTabBg2  text-text-act font-extrabold ' style={{"fontSize":"12px"}}>NFT</button>
                    </div>

                </div>

               

                {
                    showMint?(
                        <>
                             {/* mint */}
                            {/* <div className=' w-full h-8 px-4 flex flex-row items-center' >
                                <div className=' w-2/3 h-8 flex flex-row items-center text-sm'>
                                    
                                    
                                    <span><CountUp start={0} end={minted} duration="1" decimals={0} /> / <CountUp start={0} end={maxMint} duration="1" decimals={0} /></span>
                                    <span className='ml-2'>{t('mint.张')}</span>
                                </div>
                                <div className=' w-1/3 h-8 flex flex-row items-center justify-end text-lg'>
                                    <div className=' w-24 h-8  flex flex-row justify-end items-center font-bold miao text-red-500'>
                                        <span className=' '><CountUp start={0} end={per} duration="1" decimals={2} />%</span>
                                    </div>
                                </div>
                            </div>

                            <div className=' w-full px-4  mt-0 mb-5 flex flex-row items-center'>
                               
                                <div className=' w-full  flex flex-row items-center justify-center'>
                                
                                <Progress  strokeColor={{to: '#FF8C29',from: '#730005',}} status="active"  showInfo={false}   percent={per} width={20} strokeWidth={12} />
                                </div>
                            </div> */}

                            <div className='  w-80 h-48 mx-auto  flex flex-col mb-6  mintbuy  px-8 pt-12 mt-1 ' style={{"zIndex":"10"}}>
                                <div className='w-full flex flex-row items-center justify-around'>
                                    <span className='w-1/2 text-xs'>{t('mint.船票数量')}</span>
                                    <div className=' w-1/2 flex flex-row items-center justify-around'>
                                        <div onClick={sub} className=' w-6 h-6 text-black text-lg font-bold bg-gray-500 rounded-full flex flex-row justify-center items-center'>-</div>
                                        <div className=' mx-2 w-16 h-8 bg-black rounded-full flex flex-row justify-center items-center border border-gray-500'>
                                            <input  type="number"  onInput={(e)=>handleChange(e.target.value)} value={mints}  className=' w-full h-12 text-sm text-white input1 text-center '  />
                                        </div>
                                        <div onClick={add} className=' w-6 h-6 text-black text-lg font-bold bg-gray-400 rounded-full flex flex-row justify-center items-center'>+</div>
                                    </div>
                                </div>
                                <div className='w-full flex flex-row items-center mt-5'>
                                    <span className='w-1/2 text-xs'>{t('mint.需要支付')}</span>
                                    <span className='w-1/2 text-right text-xs text-text-act'>{bnb} BNB</span>
                                </div>
                                <div className='w-full flex flex-row items-center mt-5'>
                                    <span className='w-1/2 text-xs'>{t('mint.可铸造量')}</span>
                                    <span className='w-1/2 text-right text-xs text-text-act'>{pm} $MARS</span>
                                </div>
                            </div>

                            <div className='w-full flex flex-row justify-center items-center mt-5 z-10'>
                                <button  onClick={_isStartIdo} style={{"height":"53px"}} className='w-1/2   send_bg text-base text-text1 font-extrabold '>{t('mint.已结束')}</button>
                            </div>

                            {/* <div className=' w-full flex flex-row mb-6 h-96 mintbuy'>
                                <div className=' w-1/6 flex flex-row justify-start'>
                                    <img onClick={sub} alt='rr' className='' src={require('../../assets/icon/sub.png')} style={{"width":"70%"}}></img>
                                </div>
                                <div className=' w-4/6 flex flex-col'>
                                    <div className=' w-full h-9 px-4 flex felx-row items-center input_bg'>
                                        <div className=' w-2/3 h-9 flex flex-row items-center justify-start'>
                                            <span className=' text-xs text-text1'>{t('mint.张数')}</span>
                                        </div>
                                        
                                        <div className=' w-2/3 h-9 flex flex-row items-center justify-start'>
                                            <input  type="number"  onInput={(e)=>handleChange(e.target.value)} value={mints}  className=' w-full h-12 text-sm text-white input1 '     placeholder={t('mint.请输入张数')}  />
                                        </div>
                                    </div>
                                </div>
                                <div className=' w-1/6 flex flex-row justify-end'>
                                    <img onClick={add} alt='rr' className='' src={require('../../assets/icon/add.png')} style={{"width":"70%"}}></img>
                                </div>
                            </div> */}
                            {/* <div className=' w-full flex flex-row mb-6'>
                                <div className=' w-1/6'></div>
                                <div className=' w-4/6 flex flex-col'>
                                    <div className=' w-full h-9 px-4 flex felx-row items-center input_bg'>
                                        <div className=' w-2/3 h-9 flex flex-row items-center justify-start'>
                                            <span className=' text-xs text-text1'>X314RUNE</span>
                                        </div>
                                        
                                        <div className=' w-2/3 h-9 flex flex-row items-center justify-start'>
                                            <input  type="number"    className=' w-full h-12 text-sm text-white input1 '  disabled value={pm}   placeholder={t('mint.代币数量')}  />
                                        </div>
                                    </div>
                                </div>
                                <div className=' w-1/6'></div>
                            </div>
                            <div className=' w-full flex flex-row mb-6'>
                                <div className=' w-1/6'></div>
                                <div className=' w-4/6 flex flex-col'>
                                    <div className=' w-full h-9  px-4 flex felx-row items-center input_bg'>
                                        <div className=' w-2/3 h-9 flex flex-row items-center justify-start'>
                                            <span className=' text-xs text-text1'>BNB</span>
                                        </div>
                                        
                                        <div className=' w-2/3 h-9 flex flex-row items-center justify-start'>
                                            <input  type="number"    className=' w-full h-12 text-sm text-white input1 ' disabled value={bnb}    placeholder={t('mint.需BNB')}  />
                                        </div>
                                    </div>
                                </div>
                                <div className=' w-1/6'></div>
                            </div> */}

                            
                        </>
                    ):(
                        <>
                            {/* node */}
                            <div className=' w-full h-6 mt-6  pt-1 flex flex-row justify-center items-center title_bg '>
                                <span className=' text-sm text-title-text'>{t('mint.选择节点')}</span>
                            </div>

                            <div className=' w-full h-52 mt-7  flex flex-row items-center justify-around relative'>
                                {/* <div onClick={()=>changeNode(1)} className=' w-36 h-44 nodebg flex flex-col justify-center items-center'>
                                    <img alt='rr' className=' mr-1' src={require('../../assets/bg/1.png')} style={{"width":"57px"}}></img>
                                    <span className=' text-sm text-text-act mt-5'>1000 USDT</span>
                                    <span className=' text-xs text-white mt-2'>剩余数量:12</span>
                                </div> */}
                                {
                                    nodeIndex==0?(
                                         <div onClick={()=>changeNode(2)} className=' w-36 h-44 nodebg flex flex-col justify-center items-center'>
                                            <img alt='rr' className=' mr-1' src={require('../../assets/bg/3.png')} style={{"width":"57px"}}></img>
                                            <span className=' text-sm text-text-act mt-5'><CountUp start={0} end={5000} duration="1" decimals={2} /> USDT</span>
                                            {/* <span className=' text-xs text-white mt-2'>{t('mint.剩余')}:<CountUp start={0} end={12} duration="1" decimals={0} /></span> */}
                                            <span className=' text-sm text-white mt-2'>{t('mint.星穹节点')}</span>
                                        </div>
                                    ):(
                                         <div onClick={()=>changeNode(0)} className=' w-36 h-44 nodebg flex flex-col justify-center items-center'>
                                            <img alt='rr' className=' mr-1' src={require('../../assets/bg/1.png')} style={{"width":"57px"}}></img>
                                            <span className=' text-sm text-text-act mt-5'><CountUp start={0} end={1000} duration="1" decimals={2} /> USDT</span>
                                             {/* <span className=' text-sm text-white mt-2'>{t('mint.剩余')}:<CountUp start={0} end={12} duration="1" decimals={0} /></span> */}
                                            <span className=' text-sm text-white mt-2'>{t('mint.星辰节点')}</span>
                                        </div>
                                    )
                                }
                                {/* <div onClick={()=>changeNode(2)} className=' w-36 h-44 nodebg flex flex-col justify-center items-center'>
                                    <img alt='rr' className=' mr-1' src={require('../../assets/bg/2.png')} style={{"width":"57px"}}></img>
                                    <span className=' text-sm text-text-act mt-5'>3000 USDT</span>
                                    <span className=' text-xs text-white mt-2'>剩余数量:12</span>
                                </div> */}
                                {
                                    nodeIndex==1?(
                                        <div onClick={()=>changeNode(2)} className=' w-36 h-44 nodebg flex flex-col justify-center items-center'>
                                            <img alt='rr' className=' mr-1' src={require('../../assets/bg/3.png')} style={{"width":"57px"}}></img>
                                            <span className=' text-sm text-text-act mt-5'><CountUp start={0} end={5000} duration="1" decimals={2} /> USDT</span>
                                            {/* <span className=' text-xs text-white mt-2'>{t('mint.剩余')}:<CountUp start={0} end={12} duration="1" decimals={0} /></span> */}
                                            <span className=' text-sm text-white mt-2'>{t('mint.星穹节点')}</span>
                                        </div>
                                    ):(
                                        <div onClick={()=>changeNode(1)} className=' w-36 h-44 nodebg flex flex-col justify-center items-center'>
                                            <img alt='rr' className=' mr-1' src={require('../../assets/bg/2.png')} style={{"width":"57px"}}></img>
                                            <span className=' text-sm text-text-act mt-5'><CountUp start={0} end={3000} duration="1" decimals={2} /> USDT</span>
                                            {/* <span className=' text-xs text-white mt-2'>{t('mint.剩余')}:<CountUp start={0} end={12} duration="1" decimals={0} /></span> */}
                                            <span className=' text-sm text-white mt-2'>{t('mint.星耀节点')}</span>
                                        </div>
                                    )
                                }

                                
                                {
                                    nodeIndex==0?(
                                        
                                        <div  className=' w-44 h-52 nodebg absolute flex flex-col justify-center items-center'>
                                            <img alt='rr' className=' mr-1' src={require('../../assets/bg/1.png')} style={{"width":"73px"}}></img>
                                            <span className=' text-base text-text-act mt-5'><CountUp start={0} end={1000} duration="1" decimals={2} /> USDT</span>
                                            {/* <span className=' text-sm text-white mt-2'>{t('mint.剩余')}:<CountUp start={0} end={12} duration="1" decimals={0} /></span> */}
                                            <span className=' text-sm text-white mt-2'>{t('mint.星辰节点')}</span>
                                        </div>
                                    ):nodeIndex==1?(
                                        <div  className=' w-44 h-52 nodebg absolute flex flex-col justify-center items-center'>
                                            <img alt='rr' className=' mr-1' src={require('../../assets/bg/2.png')} style={{"width":"73px"}}></img>
                                            <span className=' text-base text-text-act mt-5'><CountUp start={0} end={3000} duration="1" decimals={2} /> USDT</span>
                                            {/* <span className=' text-sm text-white mt-2'>{t('mint.剩余')}:<CountUp start={0} end={34} duration="1" decimals={0} /></span> */}
                                              <span className=' text-sm text-white mt-2'>{t('mint.星耀节点')}</span>
                                        </div>
                                    ):(
                                        <div  className=' w-44 h-52 nodebg absolute flex flex-col justify-center items-center'>
                                            <img alt='rr' className=' mr-1' src={require('../../assets/bg/3.png')} style={{"width":"73px"}}></img>
                                            <span className=' text-base text-text-act mt-5'><CountUp start={0} end={5000} duration="1" decimals={2} /> USDT</span>
                                            {/* <span className=' text-sm text-white mt-2'>{t('mint.剩余')}:<CountUp start={0} end={12} duration="1" decimals={0} /></span> */}
                                            <span className=' text-sm text-white mt-2'>{t('mint.星穹节点')}</span>
                                        </div>
                                    )
                                }
                                {/* <div onClick={()=>changeNode(3)} className=' w-44 h-52 nodebg absolute flex flex-col justify-center items-center'>
                                    <img alt='rr' className=' mr-1' src={require('../../assets/bg/3.png')} style={{"width":"73px"}}></img>
                                    <span className=' text-base text-text-act mt-5'>5000 USDT</span>
                                    <span className=' text-sm text-white mt-2'>剩余数量:12</span>
                                </div> */}

                            </div>



                            {/* <div className=' w-full flex flex-row mb-6'>
                                <div className=' w-1/6 flex flex-row justify-start'>
                                    <img onClick={subNode} alt='rr' className='' src={require('../../assets/icon/sub.png')} style={{"width":"70%"}}></img>
                                </div>
                                <div className=' w-4/6 flex flex-col'>
                                    {needUsdt}
                                </div>
                                <div className=' w-1/6 flex flex-row justify-end'>
                                    <img onClick={addNode} alt='rr' className='' src={require('../../assets/icon/add.png')} style={{"width":"70%"}}></img>
                                </div>
                            </div> */}
                        
                            

                            <div className='w-full flex flex-row justify-center items-center mt-7 z-10'>
                                <button  onClick={_rand} style={{"height":"53px"}} className='w-1/2     send_bg text-base text-text1 font-extrabold '>{t('mint.确认兑换')}</button>
                            </div>
                        </>
                    )
                }


               



                
                {/*  */}
                {
                    showMint?(
                        <div className=' w-full h-10 mt-9 invite_bg flex flex-row items-center justify-center'>
                            <div className=' w-full h-10 flex flex-row items-center justify-center'>
                                {/* <img alt='rr' className=' mr-1' src={require('../../assets/icon/ji.png')} style={{"width":"32px"}}></img> */}
                                {
                                    mintBnb<=0?(
                                        <span className='ml-2 text-gray-300'>{t('mint.暂无兑换记录')} </span>
                                    ):(
                                        <span className='ml-2 text-title-text'>{t('mint.我的')}:{mintBnb*5000000} MARS ={mintBnb} BNB minted </span>
                                    )
                                }
                                
                                {/* <span className='ml-2'>1张=63(05-12 12:12:00 minted) </span> */}
                            </div>
                        </div>
                    ):(
                        <div className=' w-full h-10 mt-9 invite_bg flex flex-row items-center justify-center'>
                    <div className=' w-full h-10 flex flex-row items-center justify-center'>
                        {/* <img alt='rr' className=' mr-1' src={require('../../assets/icon/ji.png')} style={{"width":"32px"}}></img> */}
                        {
                            mintBnb<=0?(
                                <span className='ml-2 text-gray-300'>{t('mint.节点记录')} </span>
                            ):(
                                <span className='ml-2 text-title-text'>{t('mint.我的')}:{myNode} USDT </span>
                            )
                        }
                        
                        {/* <span className='ml-2'>1张=63(05-12 12:12:00 minted) </span> */}
                    </div>
                </div>
                    )
                }
                

                

                <div className=' w-full mt-12 flex flex-row justify-center items-center z-10'>
                     <img onClick={openNewPagex} alt='rr' className=' mr-5 ' src={require('../../assets/icon/tt.png')} style={{"width":"25px"}}></img>
                      <img onClick={openNewPaget} alt='rr' className=' ' src={require('../../assets/icon/tel.png')} style={{"width":"25px"}}></img>
                </div>

                <div className=' w-full mt-2 font10 text-gray-300 flex flex-row justify-center items-center'>
                     CopyRight@ Interstellar Protocol 2025
                </div>

                <div className=' w-full h-32'></div>
            </div>
            
            
               
           <Foot/>
        </>
    );
}

const mapDispatchToProps = (dispatch) =>{
    return{

        setIsLogin(value){
            const action ={type:"setIsLogin",value:value}
            dispatch(action)
        },

        setPAddress(value){
            const action ={type:"setPAddress",value:value}
            dispatch(action)
        },
        setFlash(value){
            const action ={type:"setFlash",value:value}
            dispatch(action)
        }
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Mint);
